import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-last-message',
  templateUrl: './item-last-message.component.html',
  styleUrls: ['./item-last-message.component.css']
})
export class ItemLastMessageComponent implements OnInit {
  users = [
    {
      name : 'Anthony Nguyen',
      info: 'Por favor enviar certificado de estudios.',
      status: true
    },
    {
      name : 'Kathy Carpenter',
      info: 'Por favor enviar certificado de estudios.',
      status: false
    },
    {
      name : 'Julie Hopkins',
      info: 'Por favor enviar certificado de estudios.',
      status: false
    }
  ];

  constructor() { }

  ngOnInit() {
  }

  

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-last-message/item-last-message.component.ts